<script setup>
import { computed } from "vue";

const props = defineProps(["label", "options", "modelValue", "disabled"]);
const emit = defineEmits(["update:modelValue"]);

// Accept either plain string options or { value, label } objects.
const normalisedOptions = computed(() =>
    (props.options ?? []).map((opt) =>
        typeof opt === "object" && opt !== null
            ? { value: opt.value, label: opt.label }
            : { value: opt, label: opt },
    ),
);

// Resolve by index so the original value type (null, ULID string, …) is preserved
// instead of the coerced DOM string.
function onChange(event) {
    const opt = normalisedOptions.value[event.target.selectedIndex];
    emit("update:modelValue", opt ? opt.value : null);
}
</script>

<template>
    <div class="flex flex-col gap-2">
        <label
            class="body-sm faded-text leading-[0.9] font-bold tracking-tight uppercase"
        >
            {{ label }}
        </label>
        <div class="relative">
            <select
                :disabled="disabled"
                class="bg-marine-800 border-marine-500 body-md h-12 w-full cursor-pointer appearance-none border px-6 pr-12 font-medium text-white uppercase disabled:cursor-not-allowed disabled:opacity-50"
                @change="onChange"
            >
                <option
                    v-for="opt in normalisedOptions"
                    :key="opt.label"
                    :selected="opt.value === modelValue"
                >
                    {{ opt.label }}
                </option>
            </select>
            <svg
                class="pointer-events-none absolute top-1/2 right-6 size-4 -translate-y-1/2 text-yellow-400"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M4 6l4 4 4-4"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>
    </div>
</template>
